/* __next_internal_client_entry_do_not_use__ MarketLinksSection auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MarketNavElements } from "@faire/retailer-visitor-shared/features/FaireMarkets/Navigation/MarketNavElements";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { HeaderLine } from "../styled";
export var MarketLinksSection = function() {
    var showNavHeader = useMarketStore([
        "showNavHeader"
    ]).showNavHeader;
    return showNavHeader ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MarketNavElements, {}),
            /*#__PURE__*/ _jsx(HeaderLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            })
        ]
    }) : null;
};
